export default "__VITE_ASSET__D_gFSXvL__"